import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);
export const useAuth = () => {
  const c = useContext(AuthContext);
  if (!c) throw new Error('useAuth must be within AuthProvider');
  return c;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || sessionStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (token) {
        try {
          const r = await api.get('/auth/me');
          setUser(r.data.user);
        } catch {
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };
    load();
  }, [token]);

  const login = (t, u, remember = false) => {
    if (remember) localStorage.setItem('token', t);
    else sessionStorage.setItem('token', t);
    setToken(t);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('activeRestaurantId');
    setToken(null);
    setUser(null);
  };

  // Refresh user from server (after profile update)
  const refreshUser = async () => {
    try {
      const r = await api.get('/auth/me');
      setUser(r.data.user);
      return r.data.user;
    } catch {
      return null;
    }
  };

  const role = user?.role;
  return (
    <AuthContext.Provider value={{
      user, token, loading, login, logout, refreshUser,
      isAuthenticated: !!token && !!user,
      isOwner: role === 'owner',
      isManager: role === 'manager',
      isEmployee: role === 'employee',
      isOwnerOrManager: role === 'owner' || role === 'manager',
      // legacy
      isAdmin: role === 'owner'
    }}>
      {children}
    </AuthContext.Provider>
  );
};
